<template>
  <section class="ma-4 ma-md-8">
    <t-page-title title="Eventos | Editar">
      <template #prepend-custom-action>
        <v-btn
          v-tooltip="'Configurar gateway'"
          icon="fa-regular fa-cog"
          color="primary"
          :loading="$loader.loading"
          @click="configGateway()"
        />
      </template>
    </t-page-title>
    <v-row justify="center" align="center">
      <v-col>
        <form-event v-if="event !== null" :event="event" @submit="submit" />
      </v-col>
    </v-row>
  </section>
  <v-dialog v-model="dialog" max-width="720">
    <v-card>
      <div id="gateway-config" />
    </v-card>
  </v-dialog>
</template>

<script lang="ts" setup>

import TPageTitle from '@/components/TPageTitle.vue'
import EventService from '@/services/EventService'
import { useLoader } from '@/stores/loader'
import Event from '@/types/Event'
import { Ref, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import FormEvent from './form-event.vue'
import { ImageState } from './partials/form-event-images.vue'
import { useSnackBar } from '@/stores/snackbar'
import { http } from '@/plugins/http'
import { SectorConfigState } from './partials/form-event-sectors.vue'

const route = useRoute()
const router = useRouter()
const snackbar = useSnackBar()
const loader = useLoader()

const event: Ref<Event | null> = ref(null)
const dialog: Ref<boolean> = ref(false)

async function fetch() {
  const { id } = route.params

  if (id) {
    const response = await new EventService().show(id as string)

    event.value = response.data.data
  }
}

async function submit(model: Event, images: ImageState[], sectorConfigs: SectorConfigState[]) {
  try {
    loader.increment()

    await new EventService().update(
      model.id,
      model,
      images.filter(image => image.dirty),
      sectorConfigs,
    )

    snackbar.show('Evento atualizado com sucesso', 'success')
    loader.decrement()

    router.push({ name: 'list-events' })
  } catch {
    loader.decrement()
  }
}

async function configGateway() {
  const response = await http.get(`/api/v1/office/payment-gateways/${event.value?.id}/config`)

  console.log(response.data)
  dialog.value = true

  setTimeout(() => {
    window.IngresseReconfig.mount('gateway-config', response.data.data.reconfigUrl)
  }, 1000)
}

fetch()

</script>
